export default "__VITE_ASSET__BczExMXC__"